export { useLocalNotes } from "./useLocalNotes";
export type { LocalNotesContextType } from "./useLocalNotes";
export { LocalNoteManager } from "./LocalNoteManager";
